import { createRoutine } from 'redux-saga-routines';
import {
  GET_STORED_REGISTRATIONS,
  CREATE_REGISTRATION,
  UPDATE_REGISTRATION,
  INIT_REGISTRATION,
  SET_ACTIVE_REGISTRATION,
  SEARCH_AGENCIES,
  CREATE_PROFILE,
  GET_PRODUCTS,
  GET_SUBSCRIPTIONS,
  SET_REGISTRATION_PROFILE,
} from './constants';

export const getRegistrationsAction = createRoutine(GET_STORED_REGISTRATIONS);
export const getProductsAction = createRoutine(GET_PRODUCTS);
export const getSubscriptionsAction = createRoutine(GET_SUBSCRIPTIONS);
export const setActiveRegistrationsAction = createRoutine(SET_ACTIVE_REGISTRATION);
export const setRegistrationProfileAction = createRoutine(SET_REGISTRATION_PROFILE);
export const createRegistrationAction = createRoutine(CREATE_REGISTRATION);
export const initRegistrationAction = createRoutine(INIT_REGISTRATION);
export const updateRegistrationAction = createRoutine(UPDATE_REGISTRATION);
export const searchAgenciesAction = createRoutine(SEARCH_AGENCIES);
export const createProfileAction = createRoutine(CREATE_PROFILE);
